import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface IAgentSummaryResponse {
  totalAgents: number;
  onlineAgents: number;
  capacityUtilisation: number;
  unusedCapacity: number;
  unallocatedAgents: number;
  nilAllocatedAgents: number;
}

export interface AgentSummaryState {
  agentSummary: IAgentSummaryResponse | null;
  loading: boolean;
  error: string | null;
}

export const initialState: AgentSummaryState = {
  agentSummary: null,
  loading: false,
  error: null,
};

interface IAgentSummaryRequest {
  supervisorId: string;
  type: string;
}

const agentSummarySlice = createSlice({
  name: 'agentSummary',
  initialState,
  reducers: {
    fetchAgentSummary: (state, action: PayloadAction<IAgentSummaryRequest>) => {
      state.loading = true;
      state.error = null;
    },
    fetchAgentSummarySuccess: (
      state,
      action: PayloadAction<IAgentSummaryResponse>
    ) => {
      state.agentSummary = action.payload;
      state.loading = false;
    },
    fetchAgentSummaryFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const {
  fetchAgentSummary,
  fetchAgentSummarySuccess,
  fetchAgentSummaryFailure,
} = agentSummarySlice.actions;

export default agentSummarySlice.reducer;
